export enum NavigatorsDataIndex {
  'full_name' = 'full_name',
  'email' = 'email',
  'created_at' = 'created_at',
  'updated_at' = 'updated_at',
}
